// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"paste-modal_wrapper__c8FrQ","west":"paste-modal_west__2Nf23","east":"paste-modal_east__1dFwe","main":"paste-modal_main__ipSwY","footer":"paste-modal_footer__1eKkc"};